import 'babel-polyfill'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/main.css';
import './assets/css/vue-select.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faPlus, faMinus, faChevronRight, faChevronDown, faToggleOff, faToggleOn, faCheck, faCheckCircle, faTimesCircle, faAngleDoubleRight, faPlusCircle, faMinusCircle, faQuestionCircle, faUserTimes } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare as farCheckSquare, faSquare as farSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vuelidate from "vuelidate";
import vSelect from "vue-select";
import VueSanitize from "vue-sanitize";
//import VModal from 'vue-js-modal';
//import { BootstrapVue } from 'bootstrap-vue';
import { ModalPlugin, ButtonPlugin, TablePlugin, TabsPlugin, SpinnerPlugin, CollapsePlugin, CardPlugin, PaginationPlugin, TooltipPlugin } from 'bootstrap-vue';
//import VueResource from 'vue-resource'
//import VueMoment from 'vue-moment';

import sanitizeHtml from 'sanitize-html';

function deepSet(obj, value, path) {
    var i;
    path = path.split('.');
    for (i = 0; i < path.length - 1; i++)
        obj = obj[path[i]];

    obj[path[i]] = sanitizeHtml(value, config);
}

const config = {
    allowedTags: [],
    allowedAttributes: {}
}

Vue.directive('sanitize-html', {
    bind: function (el, binding, vnode) {
        var select = (el);
        select.value = sanitizeHtml(select.value, config);
        if (binding.expression)
            deepSet(vnode.context.$data, select.value, binding.expression);
        select.addEventListener('change', function () {
            if (binding.expression)
                deepSet(vnode.context.$data, select.value, binding.expression);
        });
    },
    update: function (el, binding, vnode) {
        var select = (el);
        var sanitized_value = sanitizeHtml(select.value, config);
        select.addEventListener('paste', async () => {
            binding.value = await navigator.clipboard.readText();
            sanitized_value = sanitizeHtml(binding.value, config);
            binding.value = sanitized_value
            // await navigator.clipboard.writeText(sanitized_value);
        });
        select.addEventListener('change', function (e) {
            sanitized_value = sanitizeHtml(e.target.value, config);
            e.target.value = sanitized_value
            select.value = sanitized_value
            binding.value = sanitized_value

            if (binding.expression)
                deepSet(vnode.context.$data, select.value, binding.expression);
        });
    }
});

library.add(faSearch, faPlus, faMinus, faChevronRight, faChevronDown, faToggleOff, faToggleOn, faCheck, faCheckCircle, faTimesCircle, faAngleDoubleRight, farCheckSquare, farSquare, faPlusCircle, faMinusCircle, faQuestionCircle, faUserTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component("v-select", vSelect)

Vue.config.productionTip = false;

export const eventbus = new Vue();

Vue.prototype.$http = axios;
Vue.use(Vuelidate);
//Vue.use(VModal)
//Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(ButtonPlugin);
Vue.use(TablePlugin);
Vue.use(TabsPlugin);
Vue.use(SpinnerPlugin);
Vue.use(CollapsePlugin);
Vue.use(CardPlugin);
Vue.use(PaginationPlugin);
Vue.use(TooltipPlugin);
Vue.use(VueSanitize);
//Vue.use(VueResource);
//Vue.use(VueMoment);


new Vue({
    methods: {
        encodeForm: function (data) {
            return Object.keys(data).map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]); }).join('&');
        }
    },
    router,
    store,
    render: h => h(App)
}).$mount('#app');
